import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ShopData } from "../types";

dayjs.extend(utc);
dayjs.extend(timezone);

type BookingAppointmentType = string | undefined;

const parseNonNegativeNumber = (value: unknown): number | null => {
  if (
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return null;
  }

  if (typeof value !== "number" && typeof value !== "string") {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
};

const getTypeConfig = (
  shopData: ShopData | undefined,
  apptType: BookingAppointmentType
) => {
  if (apptType === "wait") return shopData?.waiters;
  if (apptType === "drop") return shopData?.dropOffs;
  return undefined;
};

export const getShopNow = (shopData: ShopData | undefined) => {
  return shopData?.timezone ? dayjs().tz(shopData.timezone) : dayjs();
};

export const toShopTime = (
  value: dayjs.ConfigType,
  shopData: ShopData | undefined
) => {
  if (
    shopData?.timezone &&
    typeof value === "string" &&
    !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)
  ) {
    return dayjs.tz(value, shopData.timezone);
  }

  const parsed = dayjs(value);
  return shopData?.timezone ? parsed.tz(shopData.timezone) : parsed;
};

export const resolveSameDayBookings = (
  shopData: ShopData | undefined,
  apptType: BookingAppointmentType
): boolean => {
  return (
    getTypeConfig(shopData, apptType)?.sameDayBookings ??
    shopData?.sameDayBookings ??
    false
  );
};

export const resolveSameDayBufferMinutes = (
  shopData: ShopData | undefined,
  apptType: BookingAppointmentType
): number => {
  return (
    parseNonNegativeNumber(
      getTypeConfig(shopData, apptType)?.sameDayBufferMinutes
    ) ??
    parseNonNegativeNumber(shopData?.slotBufferMinutes) ??
    0
  );
};
